
import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "productos",
    "productos",
    "productoForm",
    "/productos",
);

export default handleActions(reducers, initialState);
